var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUpIcon = function SvgThumbsUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.246 1.461a.92.92 0 0 1 .837-.544 3.667 3.667 0 0 1 3.667 3.666v2.75h4.267a2.75 2.75 0 0 1 2.744 3.163l-1.265 8.25a2.75 2.75 0 0 1-2.744 2.337H3.667a2.75 2.75 0 0 1-2.75-2.75v-6.416a2.75 2.75 0 0 1 2.75-2.75H5.82zm-1.913 8.817 3.307-7.441a1.83 1.83 0 0 1 1.276 1.746V8.25c0 .506.41.917.917.917h5.198a.916.916 0 0 1 .918 1.053l-1.266 8.25a.916.916 0 0 1-.916.78H7.333zM5.5 19.25V11H3.667a.917.917 0 0 0-.917.917v6.416a.917.917 0 0 0 .917.917z",
    clipRule: "evenodd"
  })));
};
export default SvgThumbsUpIcon;